<template>
  <div>
    <!-- TODO: add loading status      -->
    <p>Checking NHS code</p>
  </div>
</template>
<script setup lang="ts">
  import { onMounted } from 'vue';
  import { useNhsLogin } from '../composables/useNhsLogin';
  import { RequestTypeBroad } from '../../types';
  import { useRouter } from 'vue-router';
  import { useSessionStore } from '../../stores/useSessionStore';
  import { useProvidedSessionInactivity } from '../composables/useProvidedSessionInactivity';
  import { useErrorStore } from '../../stores/useErrorStore';

  const router = useRouter();
  const session = useSessionStore();
  const inactivity = useProvidedSessionInactivity();
  const errorStore = useErrorStore();

  async function navigateForRequestType(requestType: RequestTypeBroad) {
    if (requestType === 'medical-request') {
      await router.push('/medical-request/');
      return;
    }
    if (requestType === 'admin-request') {
      await router.push('/admin-request/');
      return;
    }
    if (requestType === 'repeat-prescription-request') {
      // NB. no medical warning needed.
      await router.push('/repeat-prescription-request/prescriptions-list');
      return;
    }
  }

  const nhsLogin = useNhsLogin({
    onSuccess: async ({ requestType }) => {
      session.startSession(Date.now());
      inactivity.start();
      // for nearly ending session counter
      await navigateForRequestType(requestType);
    },
    onNhsError: async ({ error, description }) => {
      const errorForStore = [{ code: error?.trim(), message: description }];
      errorStore.setErrors(errorForStore);
      errorStore.setError({ message: description });
      errorStore.setIsNhsError(true);
    },
  });

  onMounted(() => {
    nhsLogin.start();
  });
</script>
